export default __webpack_public_path__ + "static/media/layer04.ed646e25.png";